import React from 'react'
import { Breadcrumb, Label, Image } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import EllipsisTooltip from './../../../../common/EllipsisTooltip'
class BreadCrumbsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    navigateTo(path) {
        const history = this.props.history;
        if(path === "/myactivities"){
            dispatch.initiatives.setPageStatus(null);
        } else if(this.props.match.params.initiativeStatus){
            dispatch.initiatives.setPageStatus(this.props.match.params.initiativeStatus);
        }
        dispatch.initiatives.setSelectedActivityData({});
        dispatch.initiatives.showResourecePane(null);
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_at${path}`
        });
    }
    render() {
        let initiativeStatus = this.props.match.params.initiativeStatus === "completedInitiatives" ? "Completed" 
                               :this.props.match.params.initiativeStatus === "activeInitiatives" ? "Active": null;

        let setSelectedActivityData = Object.entries(this.props.selectedActivityData).length !== 0 && this.props.selectedActivityData.constructor === Object
        let breadcrumb;
        if (!setSelectedActivityData && !this.props.initiativeId && initiativeStatus) {
            breadcrumb = <span>
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section>
                    <EllipsisTooltip
                        name={initiativeStatus}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
            </span>
        }
        else if (!setSelectedActivityData && this.props.initiativeId) {
            let inititativeName;
            this.props.initiativeCountDataForMember && this.props.initiativeCountDataForMember.activeInitiatives.map((item, i) => {
                if (item.id === this.props.initiativeId) {
                    inititativeName = item.name;
                }
            });
            this.props.initiativeCountDataForMember && this.props.initiativeCountDataForMember.completedInitiatives.map((item, i) => {
                if (item.id === this.props.initiativeId) {
                    inititativeName = item.name;
                }
            });
            breadcrumb = <span>
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section onClick={()=>{this.navigateTo(`/myactivities/${initiativeStatus.toLowerCase()}Initiatives`)}}>
                    <EllipsisTooltip
                        name={initiativeStatus}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section>
                    <EllipsisTooltip
                        name={inititativeName}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
            </span>
        } else if (setSelectedActivityData && !this.props.initiativeId) {
            this.props.initiativeCountDataForMember && this.props.initiativeCountDataForMember.activeInitiatives.map((item, i) => {
                if (this.props.selectedActivityData && this.props.selectedActivityData.initiativeId && this.props.selectedActivityData.initiativeId._id === item.id) {
                    initiativeStatus = "Active";
                }
            });
            this.props.initiativeCountDataForMember && this.props.initiativeCountDataForMember.completedInitiatives.map((item, i) => {
                if (this.props.selectedActivityData && this.props.selectedActivityData.initiativeId && this.props.selectedActivityData.initiativeId._id === item.id) {
                    initiativeStatus = "Completed";
                }
            });
            breadcrumb = <span>
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section onClick={()=>{this.navigateTo(`/myactivities/${initiativeStatus.toLowerCase()}Initiatives`)}}>
                    <EllipsisTooltip
                        name={initiativeStatus}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section onClick={()=>{this.navigateTo(`/myactivities/${initiativeStatus.toLowerCase()}Initiatives/${this.props.selectedActivityData.initiativeId._id}`)}}>
                    <EllipsisTooltip
                        name={this.props.selectedActivityData && this.props.selectedActivityData.initiativeId && this.props.selectedActivityData.initiativeId.name}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section>
                    <EllipsisTooltip
                        name={this.props.selectedActivityData.name}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
            </span>

        } else if (setSelectedActivityData && this.props.initiativeId) {
            breadcrumb = <span>
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section onClick={()=>{this.navigateTo(`/myactivities/${initiativeStatus.toLowerCase()}Initiatives`)}}>
                    <EllipsisTooltip
                        name={initiativeStatus}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
                <Breadcrumb.Divider icon='right angle' />
                {this.props.selectedActivityData && this.props.selectedActivityData.initiativeId && 
                <Breadcrumb.Section onClick={()=>{this.navigateTo(`/myactivities/${initiativeStatus.toLowerCase()}Initiatives/${this.props.selectedActivityData.initiativeId._id}`)}}>
                    <EllipsisTooltip
                        name={this.props.selectedActivityData.initiativeId.name}
                        position="bottom left"
                    />
                </Breadcrumb.Section>}
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section>
                    <EllipsisTooltip
                        name={this.props.selectedActivityData.name}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
            </span>


        } else {
            breadcrumb = null
        }


        let showEditor = this.props.initiativeId &&
            this.props.selectedDataById &&
            this.props.selectedDataById.status === 4 &&
            this.props.selectedDataById.createdByDetail ?
            <Label className="float-right" style={{
                "padding": "2px 2px",
                "borderRadius": "500em",
                "margin": "-7px 0 0 0",
                "background": "#248BCE",
                "color": "white"
            }}>
                <Image avatar src={this.props.selectedDataById.createdByDetail.profilePic} />
                <span style={{
                    "display": "inline-block",
                    "verticalAlign": "middle"
                }}>
                    {this.props.selectedDataById.createdByDetail.firstName}&nbsp;
                    {this.props.selectedDataById.createdByDetail.lastName}&nbsp;
                 is editing this initiative</span>
            </Label>
            : null

        return (
            <div className="w_100">  
                <Breadcrumb className="breadCrumbs " style={{ marginBottom: '10px', width: "auto" }}>
                    {initiativeStatus ? <Breadcrumb.Section  onClick={()=>{this.navigateTo("/myactivities")}}>My Progress</Breadcrumb.Section>
                    :<Breadcrumb.Section>My Progress</Breadcrumb.Section>}
                    {breadcrumb}
                </Breadcrumb>
                {showEditor}
            </div>

        )
    }
}



export default BreadCrumbsPage;